<template>
	<core-modal
		:name="campaign.id + '-trash-modal'"
		class="omapi-modal trash-modal"
		:clickToClose="!isTrashing"
		:isConfirmation="true"
	>
		<modals-content>
			<form @submit.prevent="trash">
				<p v-html="message"/>
				<p v-if="!campaign.is_split && hasSplits">This will <strong>also send the connected split tests to the trash</strong>.</p>

				<section class="buttons">
					<core-loading-button
						class="trash-campaign"
						color="blue"
						size="large"
						buttonType="submit"
						:loading="isTrashing"
						ref="toFocus"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						@click.prevent="$modal.hide(campaign.id + '-trash-modal')"
						:disabled="isTrashing"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { trash } from '@/campaigns/mixins/trash'

export default {
	mixins : [ trash ],
	props  : {
		campaign : {
			type     : Object,
			required : true,
		},
	},
	computed : {
		hasSplits () {
			return 0 < this.$get('campaign.splits', []).length
		},
		message () {
			return this.campaign.is_split
				? `Are you sure you want to <strong>permanently delete</strong> the <strong>${this.campaign.name} (${this.campaign.id})</strong> split test campaign?`
				: `Are you sure you want to send the <strong>${this.campaign.name} (${this.campaign.id})</strong> to the trash?`
		},
	},
}
</script>

<style lang="scss">
.trash-modal {

}
</style>
